import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MatDialogModule} from '@angular/material/dialog';
import { MatSelectModule} from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatAutocompleteModule} from '@angular/material/autocomplete';

@NgModule({
  declarations: [],
  imports: [
    MatAutocompleteModule,
    NgSelectModule,
    MatSelectModule,
    MatDialogModule,
    RouterModule,
    CommonModule,
    TranslateModule
  ],
  exports: [
    RouterModule,

    TranslateModule,
    CommonModule,
  ],
  providers: [NgSelectModule],
})

export class helpersModule {}
